import { CircularProgress, CircularProgressProps, LinearProgress } from '@mui/material';

import { GDMLoadingComponent, GDMLoadingType } from './GDMLoading.type';

/* TODO: Implement component using GDM default design */
const GDMLoading: GDMLoadingComponent = ({ type, ...props }) => {
  switch (type) {
    case GDMLoadingType.LINEAR:
      return <LinearProgress {...props} />;
    case GDMLoadingType.CIRCULAR:
      return <CircularProgress {...(props as CircularProgressProps)} />;
    default:
      return <CircularProgress {...(props as CircularProgressProps)} />;
  }
};

export default GDMLoading;
